import imageBlobReduce from 'image-blob-reduce';

const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
const MAX_SIZE = 2000;

const isNativeResizeSupported = () =>
  typeof createImageBitmap !== 'undefined' && typeof OffscreenCanvas !== 'undefined';

const nativeResize = async (file: File): Promise<Blob> => {
  const img = await createImageBitmap(file);

  try {
    if (img.width <= MAX_SIZE && img.height <= MAX_SIZE) return file;

    const scale = Math.min(MAX_SIZE / img.width, MAX_SIZE / img.height);
    const canvas = new OffscreenCanvas(
      Math.round(img.width * scale),
      Math.round(img.height * scale)
    );
    const ctx = canvas.getContext('2d');

    if (!ctx) return file;

    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return await canvas.convertToBlob({ type: file.type, quality: 0.9 });
  } finally {
    img.close();
  }
};

const legacyResize = async (file: File): Promise<Blob> => {
  return imageBlobReduce().toBlob(file, { max: MAX_SIZE });
};

const imageResize = async (file: File): Promise<Blob> => {
  if (!ALLOWED_FILE_TYPES.includes(file.type)) return file;

  if (isNativeResizeSupported()) {
    try {
      return await nativeResize(file);
    } catch {
      return legacyResize(file);
    }
  }

  return legacyResize(file);
};

export default imageResize;
